<div class="modal-payment-confirmed">
    <div class="modal-payment-confirmed-title">
        <h2>{{ 'modalPaymentConfirmed.title' | translate }}</h2>
    </div>
    <div class="modal-payment-confirmed-description">
        <h3>{{ 'modalPaymentConfirmed.howToUse' | translate }}</h3>
    </div>
    <div>
        <div class="modal-payment-confirmed-description">
            <p [innerHTML]="'modalPaymentConfirmed.description.description' | translate"></p>
        </div>
        <div class="modal-payment-confirmed-content">
            <img src="assets/compass/edit.png" alt="Compass Logo" class="img-compass">
            <div class="modal-payment-confirmed-content-item-container">
                <div class="modal-payment-confirmed-content-item" *ngIf="data.licenses_table.length >= 1">
                    <h3>{{ 'modalPaymentConfirmed.content.assignUser.title' | translate }}</h3>
                    <p>{{ 'modalPaymentConfirmed.content.assignUser.description' | translate }}</p>
                </div>
                <div class="modal-payment-confirmed-content-item" *ngIf="data.licenses_table.length > 1">
                    <h3>{{ 'modalPaymentConfirmed.description.titleOther' | translate }}</h3>
                    <p>{{ 'modalPaymentConfirmed.description.descriptionOther' | translate }}</p>
                </div>
                <div class="modal-payment-confirmed-content-item button-item">
                    <button mat-button (click)="close()">{{ 'modalPaymentConfirmed.description.buttonOther' | translate }}</button> 
                </div>
            </div>
        </div>
    </div>

</div>

<button mat-icon-button class="close-modal-btn" style="position: absolute; top: 10px; right: 10px;" (click)="close()" [attr.aria-label]="'modalPaymentConfirmed.close' | translate">
    <div class="close-modal-btn-container">
      <p class="close-modal-btn-text">&times;</p>
    </div>
</button>